export const AGENTS_CONSTANTS = {
  MAX_PHONE_NUMBER_CHANGES: 3,

  POLLING_INTERVAL_MS: 15000, // 15 seconds

  STATUS_COLORS: {
    stopped: 'negative',
    active: 'positive',
    action_required: 'warning',
    waiting: 'info',
    sleeping: 'grey',
    default: 'grey'
  },

  RESPONSE_RATE_DEFAULT: 2,

  RESPONSE_RATE_MAP: {
    1: {value: 600, label: 'agents.create.slow'}, //max 1 message every 10 minutes
    2: {value: 300, label: 'agents.create.medium'}, //max 1 message every 5 minutes
    3: {value: 60, label: 'agents.create.fast'}, //max 1 message every minute
  },

  TEXT_LENGTH_DEFAULT: 2,

  TEXT_LENGTH_MAP: {
    1: {value: 50, label: 'agents.create.text.short'},
    2: {value: 150, label: 'agents.create.text.medium'},
    3: {value: 300, label: 'agents.create.text.long'},
    4: {value: 500, label: 'agents.create.text.veryLong'},
  },

  EMOJI_PERCENTAGE_DEFAULT: 1,

  EMOJI_PERCENTAGE_MAP: {
    1: {value: 0, label: 'agents.create.emojiPercentage.zero'},
    2: {value: 25, label: 'agents.create.emojiPercentage.twentyFive'},
    3: {value: 50, label: 'agents.create.emojiPercentage.fifty'},
    4: {value: 75, label: 'agents.create.emojiPercentage.seventyFive'},
    5: {value: 100, label: 'agents.create.emojiPercentage.oneHundred'},
  }
}
